
const apiConfig = {
  //apiUrl: 'https://localhost:7031/api/',
  //
  apiUrl: 'https://hub-api.off-ease.com/api/',
  apiKey: 'Lieda1002',
};

export default apiConfig;
